import {Repository, createRepository} from '@/repositories/Base/Repository'

class QueueRepository extends Repository {
    endpoint = 'integration/service-queue'

    fetchService(params) {
        return this.$axios.get(`${this.endpoint}`, {params})
    }

    fetchRealized(params) {
        return this.$axios.get(`${this.endpoint}/realized`, {params})
    }

    fetchRealize(params) {
        return this.$axios.post(`${this.endpoint}/realize`, params)
    }
}

export default new QueueRepository()

export const create = createRepository(QueueRepository)
